/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-25",
    versionChannel: "nightly",
    buildDate: "2025-05-25T00:07:47.983Z",
    commitHash: "9604c6cf9f8f4f3bf6eff0c4dcc4dfb1b4bde561",
};
